import React, { Component } from "react";

import Layout from "../layout/Layout";

import "./Contact.css";

export default class Contact extends Component {
  render() {
    return (
      <Layout>
        <p>You can send me a message here, all fields are required.</p>
      </Layout>
    );
  }
}
